import { ChangeEvent } from 'react';
import Grid from '@mui/material/Grid';
import Newcustomselect from '../../../../newcustomselect/newcustomselect';
import { ExporterDetailsProps } from '../../../../../pages/dashboard/tradedocuments/tradeDocumentTypes/parkinglistTypes';
import CustomTextField from '../../../../CustomTextInput';

const BuyerDetails = ({
    errors,
    payload,
    corporatePartners,
    updateField,
    loadingCorporatepartners,
    setShowAddPartner
}: ExporterDetailsProps) => {
    return (
        <Grid container>
            <Grid item xs={12} md={12} lg={6}>
                <div className='lg:border lg:border-appcolorgreyfaint lg:px-[1rem] lg:pt-[0.1rem] lg:pb-4 lg:h-full'>
                    <div className='lg:mt-4'>
                        <Newcustomselect
                            hasError={errors?.consigneeId.length > 0}
                            helperText={
                                errors?.consigneeId.length > 0
                                    ? errors?.consigneeId
                                    : undefined
                            }
                            selectValue={payload.consigneeId}
                            required
                            selectOptions={
                                corporatePartners as unknown as Record<
                                    string,
                                    unknown
                                >[]
                            }
                            name={'consigneeId'}
                            updateField={(_, value) => {
                                updateField('consigneeId', value);
                                updateField(
                                    'consigneeAddress',
                                    corporatePartners.filter(
                                        (item: { id: string | number }) =>
                                            item?.id === value
                                    )[0]?.address
                                );
                                updateField(
                                    'consigneeName',
                                    corporatePartners.filter(
                                        (item: { id: string | number }) =>
                                            item?.id === value
                                    )[0]?.name
                                );
                                updateField(
                                    'consigneeBankName',
                                    corporatePartners.filter(
                                        (item: { id: string | number }) =>
                                            item?.id === value
                                    )[0]?.bankName
                                );
                                updateField(
                                    'consigneeSwiftCode',
                                    corporatePartners.filter(
                                        (item: { id: string | number }) =>
                                            item?.id === value
                                    )[0]?.swiftCode
                                );
                                updateField(
                                    'consigneeCountry',
                                    corporatePartners.filter(
                                        (item: { id: string | number }) =>
                                            item?.id === value
                                    )[0]?.bankCountry
                                );
                                updateField(
                                    'consigneeAccountNumber',
                                    corporatePartners.filter(
                                        (item: { id: string | number }) =>
                                            item?.id === value
                                    )[0]?.bankAccountNumber
                                );
                            }}
                            label={'Consignee'}
                            selectOptionLabel='name'
                            loading={loadingCorporatepartners}
                            dropdownRender={() => {
                                return (
                                    <div className='px-4 border-t border-appcolorgreyfaint'>
                                        <p
                                            className='px-4 py-2 cursor-pointer text-appcolorprimary'
                                            onClick={() => {
                                                setShowAddPartner(true);
                                            }}
                                        >
                                            + Add a New Partner
                                        </p>
                                    </div>
                                );
                            }}
                        />
                    </div>

                    <div className='mt-4'>
                        <Newcustomselect
                            hasError={errors?.buyerId.length > 0}
                            helperText={
                                errors?.buyerId.length > 0
                                    ? errors?.buyerId
                                    : undefined
                            }
                            selectValue={payload.buyerId}
                            selectOptions={
                                corporatePartners as unknown as Record<
                                    string,
                                    unknown
                                >[]
                            }
                            name={'buyerId'}
                            updateField={(_, value) => {
                                updateField('buyerId', value);
                                updateField(
                                    'buyerAddress',
                                    corporatePartners.filter(
                                        (item: { id: string | number }) =>
                                            item?.id === value
                                    )[0]?.address
                                );
                                updateField(
                                    'buyer',
                                    corporatePartners.filter(
                                        (item: { id: string | number }) =>
                                            item?.id === value
                                    )[0]?.name
                                );
                            }}
                            label={'Buyer (If not Consignee)'}
                            selectOptionLabel='name'
                            loading={loadingCorporatepartners}
                            dropdownRender={() => {
                                return (
                                    <div className='px-4 border-t border-appcolorgreyfaint'>
                                        <p
                                            className='px-4 py-2 cursor-pointer text-appcolorprimary'
                                            onClick={() => {
                                                setShowAddPartner(true);
                                            }}
                                        >
                                            + Add a New Partner
                                        </p>
                                    </div>
                                );
                            }}
                        />
                    </div>

                    <div className='mt-4'>
                        <CustomTextField
                            error={errors?.buyerAddress?.length > 0}
                            helperText={
                                errors?.buyerAddress?.length > 0
                                    ? errors?.buyerAddress
                                    : undefined
                            }
                            value={payload?.buyerAddress}
                            id='quotation-buyerAddress'
                            label='Buyer Address (if not Consignee)'
                            name='buyerAddress'
                            onChange={(e: ChangeEvent<HTMLInputElement>) => {
                                updateField('buyerAddress', e.target.value);
                            }}
                        />
                    </div>
                </div>
            </Grid>
            <Grid item xs={12} md={12} lg={6}>
                <div className='mt-4 lg:mt-0 lg:border lg:border-appcolorgreyfaint lg:px-[1rem] lg:pt-[1.1rem] lg:pb-4 lg:h-full'>
                    <CustomTextField
                        error={errors?.billOfLadingNumber.length > 0}
                        helperText={
                            errors?.billOfLadingNumber.length > 0
                                ? errors?.billOfLadingNumber
                                : undefined
                        }
                        value={payload?.billOfLadingNumber}
                        required
                        id='proformainvoice-billOfLadingNumber'
                        label='Bill of Lading Number'
                        name='billOfLadingNumber'
                        onChange={(e: ChangeEvent<HTMLInputElement>) => {
                            updateField('billOfLadingNumber', e.target.value);
                        }}
                    />

                    <Grid
                        container
                        spacing={1}
                        sx={{
                            marginTop: '0px'
                        }}
                    >
                        <Grid item xs={12} md={12} lg={6}>
                            <div className='mt-4'>
                                <CustomTextField
                                    error={errors?.reference.length > 0}
                                    helperText={
                                        errors?.reference.length > 0
                                            ? errors?.reference
                                            : undefined
                                    }
                                    required
                                    value={payload?.reference}
                                    id='commercialinvoice-reference'
                                    label='Reference'
                                    name='reference'
                                    onChange={(
                                        e: ChangeEvent<HTMLInputElement>
                                    ) => {
                                        updateField(
                                            'reference',
                                            e.target.value
                                        );
                                    }}
                                />
                            </div>
                        </Grid>

                        <Grid item xs={12} md={12} lg={6}>
                            <div className='mt-4 '>
                                <CustomTextField
                                    error={errors?.buyerReference.length > 0}
                                    helperText={
                                        errors?.buyerReference.length > 0
                                            ? errors?.buyerReference
                                            : undefined
                                    }
                                    required
                                    value={payload?.buyerReference}
                                    id='commercialinvoice-buyerReference'
                                    label='Buyer Reference'
                                    name='buyerReference'
                                    onChange={(
                                        e: ChangeEvent<HTMLInputElement>
                                    ) => {
                                        updateField(
                                            'buyerReference',
                                            e.target.value
                                        );
                                    }}
                                />
                            </div>
                        </Grid>
                    </Grid>
                </div>
            </Grid>
        </Grid>
    );
};

export default BuyerDetails;
